export const LOGOUT = "nitro/LOGOUT"

export const logout = () => ({
  type: LOGOUT,
})
